import posthog from "posthog-js";

posthog.init(`${appConfig.posthog.apikey}`, appConfig.posthog.params);
posthog.identify(`${appConfig.posthog.domain} ${appConfig.posthog.admin}`);
